import React from 'react';

import { Box, Typography } from '@mui/material';

interface DecisionMetricProps {
  label: string;
  value: string;
  meaning: string;
  decision: string;
}

export default function DecisionMetric({ label, value, meaning, decision }: DecisionMetricProps) {
  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 210,
        p: 2,
      }}
    >
      <Typography variant="overline" color="text.secondary" sx={{ lineHeight: 1.4 }}>
        {label}
      </Typography>
      <Typography variant="h5" sx={{ mb: 1.5 }}>
        {value}
      </Typography>
      <Typography variant="caption" color="text.secondary" fontWeight={700}>
        What it means
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        {meaning}
      </Typography>
      <Box sx={{ borderTop: '1px solid', borderColor: 'divider', mt: 'auto', pt: 1.5 }}>
        <Typography variant="caption" color="primary.main" fontWeight={700}>
          Decision it informs
        </Typography>
        <Typography variant="body2">{decision}</Typography>
      </Box>
    </Box>
  );
}
